<template>
    <section class="home-wrapper" v-once>
        <nav class="nav has-shadow user-select">
            <div class="container">
                <h1 class="title">
                    {{ Laravel.title }}
                </h1>

                <div class="flex-center">
                    <router-link to="/rules">
                        <el-button round size="small" type="text">Rules</el-button>
                    </router-link>                                        
                    <router-link to="/tos" class="margin-right-1">
                        <el-button round size="small" type="text">Terms of Service</el-button>
                    </router-link>
                    <router-link to="/privacy-policy" class="margin-right-1">
                        <el-button round size="small" type="text">Privacy Policy</el-button>
                    </router-link>
<!--                     <router-link to="/credits">
                        <el-button round size="small" type="text">Credits</el-button>
                    </router-link> -->
                </div>
            </div>
        </nav>

        <section id="page" class="home-submissions">
            <p>
                Humtog is a platform to discuss the news and issues of a country. We are currently launching in India and will soon launch in other countries.
            </p>

            <br>
<!--             <h2 class="title">Users are voters</h2>
 -->         
        </section>
    </section>
</template>

<script>
export default {
    data() {
        return {
            Laravel
        };
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/About.vue